const slideSchema = () => ({
  title: 'Slide',
  addMessage: 'Adicionar slide',
  fieldsets: [
    {
      id: 'default',
      title: 'Conteúdo',
      fields: ['title', 'description', 'imageUrl', 'imageAlt', 'url'],
    },
  ],
  properties: {
    title: {
      title: 'Título',
      widget: 'textarea',
    },
    description: {
      title: 'Linha de apoio',
      widget: 'textarea',
    },
    imageUrl: {
      title: 'URL da imagem',
      description: 'Link público da imagem (proporção recomendada 21:9).',
    },
    imageAlt: {
      title: 'Texto alternativo',
    },
    url: {
      title: 'Link do slide',
      description: 'Para onde o slide leva ao ser clicado (ex: a notícia em destaque).',
    },
  },
  required: ['title'],
});

const HeroSchema = () => ({
  title: 'Hero AgSUS',
  fieldsets: [
    {
      id: 'default',
      title: 'Slides',
      fields: ['slides', 'autoRotateSeconds'],
    },
  ],
  properties: {
    slides: {
      title: 'Slides',
      description:
        'Cada item é um slide (manchete). Com 1 só slide os controles de navegação somem.',
      widget: 'object_list',
      schema: slideSchema(),
    },
    autoRotateSeconds: {
      title: 'Rotação automática (segundos)',
      description: '0 desativa. Só aplica quando há mais de um slide.',
      type: 'integer',
      default: 0,
    },
  },
  required: [],
});

export default HeroSchema;
